import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialOrder } from './OrdersUIHelpers';

const OrdersUIContext = createContext();

export function useOrdersUIContext() {
  return useContext(OrdersUIContext);
}

export const OrderUIConsumer = OrdersUIContext.Consumer;

export function OrdersUIProvider({ OrdersUIEvents, children }) {
  const [createdOrder, setCreatedOrderBase] = useState(initialOrder);
  const [orderForView, setOrderForViewBase] = useState(initialOrder);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      //console.log('OrdersUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setCreatedOrder = useCallback((nextCreatedOrder) => {
    setCreatedOrderBase((prevCreatedOrder) => {
      if (isFunction(nextCreatedOrder)) {
        nextCreatedOrder = nextCreatedOrder(prevCreatedOrder);
      }
      if (isEqual(prevCreatedOrder, nextCreatedOrder)) {
        return prevCreatedOrder;
      }
      return nextCreatedOrder;
    });
  }, []);

  const setOrderForView = useCallback((nextOrderForView) => {
    setOrderForViewBase((prevOrderForView) => {
      if (isFunction(nextOrderForView)) {
        nextOrderForView = nextOrderForView(prevOrderForView);
      }
      if (isEqual(prevOrderForView, nextOrderForView)) {
        return prevOrderForView;
      }
      return nextOrderForView;
    });
  }, []);

  const value = {
    queryParams,
    createdOrder,
    orderForView,
    setQueryParams,
    setCreatedOrder,
    setOrderForView,
    initialOrder,
    openViewOrderDialog: OrdersUIEvents.openViewOrderDialog,
    openCreateOrderDialog: OrdersUIEvents.openCreateOrderDialog,
    openDeleteOrderDialog: OrdersUIEvents.openDeleteOrderDialog,
  };

  return (
    <OrdersUIContext.Provider value={value}>
      {children}
    </OrdersUIContext.Provider>
  );
}
